import { createReducer, on } from '@ngrx/store';

import { initialNotificationUiState, NotificationUiState } from './notification-ui.model';
import { NotificationActions } from './notification.actions';

export const notificationUiReducer = createReducer<NotificationUiState>(
  initialNotificationUiState,
  on(NotificationActions.setUnreadIndicator, (_state, { show }): NotificationUiState => ({
    showUnreadIndicator: show,
  }))
);
